import { render, staticRenderFns } from "./tab_home.vue?vue&type=template&id=70d3dafa&scoped=true&"
import script from "./tab_home.vue?vue&type=script&lang=js&"
export * from "./tab_home.vue?vue&type=script&lang=js&"
import style0 from "./tab_home.vue?vue&type=style&index=0&id=70d3dafa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3dafa",
  null
  
)

export default component.exports